import {gsap, ScrollToPlugin} from '@/lib/gsap';
import {type ClassValue, clsx} from "clsx"

import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}


/**
 * Helper function to scroll document to an element with a given ID
 * @param slug
 */
export const handleScrollToId = (slug: string) => {
    const targetElement = document.getElementById(slug.replace('#', ''));

    console.log('handleScrollToId', slug)

    if (targetElement) {

        handleScrollToElement(targetElement)
    }
};


/**
 * Helper function to scroll document to an Element
 * @param targetElement
 */
export const handleScrollToElement = (targetElement?: Element) => {


    console.log('handleScrollToElement', targetElement)

    if (targetElement) {
        const header = document.querySelector('header');
        // Use getComputedStyle to handle responsive header height
        const headerHeight = header ? parseFloat(getComputedStyle(header).height) : 96;
        const headerOffset = headerHeight || 96;
        //     const headerOffset = header?.offsetHeight || 96;

        const getScrollY = () => {
            return targetElement.getBoundingClientRect().top + window.scrollY - headerOffset;
        };

        // Detect mobile devices (simplified check)
        let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        isMobile = true
        if (isMobile) {
            // Fallback to native smooth scroll for mobile
            window.scrollTo({
                top: getScrollY(),
                behavior: 'smooth',
            });
        } else {
            gsap.to(window, {
                duration: 1,
                scrollTo: {y: getScrollY(), autoKill: true},
                ease: 'power2.out',
                overwrite: 'auto',
            });
        }
    }
};

/**
 * Helper function to pick only allowed keys from an object
 * @param obj
 * @param keys
 */
export function mapPick<T extends object, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
    const result = {} as Pick<T, K>;
    keys.forEach((key) => {
        if (key in obj) {
            result[key] = obj[key];
        }
    });
    return result;
}

/**
 * Performs a deep equality check using structuredClone (native, zero deps).
 * Handles plain objects, arrays, Dates, RegExps, and most primitives.
 * @param a - First value to compare
 * @param b - Second value to compare
 * @returns `true` if values are deeply equal
 * @limitations Does not handle functions, Symbols, or circular references
 */
export function isEqual<T>(a: T, b: T): boolean {
  try {
    // Fast path: identical references
    if (a === b) return true;

    // Use structuredClone to safely serialize and compare
    // This works for most JSON-like data and avoids function/circular issues
    return structuredClone(a) === structuredClone(b);
  } catch {
    return false;
  }
}
